/*
 * @Author: wangshengqiang
 * @Date: 2021-06-16 15:36:02
 * @LastEditTime: 2021-06-16 18:35:04
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import cn from 'classnames';
import { getState } from '@/store';
import './index.less';
export default function RowPlanBrief() {
  const PLAN_ID = getState('PLAN_ID');
  const {
    affiliationName,
    planList = [],
    name: goodsName
  } = getState('goodsDetail') || {};
  const plandObj = planList.find(item => item.id === PLAN_ID) || {};
  const {
    name
  } = plandObj;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cc-row-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cc-row-header-title"
  }, affiliationName || ''), /*#__PURE__*/React.createElement("div", {
    className: "cc-row-header-subtitle"
  }, `${goodsName || ''} - ${name || ''}`)));
}